import { app } from '../../../app';

app.factory('UserNotesService', UserNotesService);

/** @ngInject */
function UserNotesService($resource) {
    return $resource('app/rest/notes/:id', {
        id : '@id'
    }, {
        'query' : {
            method : 'GET',
            isArray : true
        },
        'get' : {
            method : 'GET'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/notes/notes.service.js